import bridge from '../core';

const apiName = 'toLogin';
/**
 * 调用原生get token方法
 * @param {JSON} data
 */

function fallback() {
    console.log('toLogin: 调用原生失败');
}

function back(data) {
    return {
        api: JSON.stringify(data),
        fallback
    };
}
bridge.register(apiName, back);
